import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";

import "../../style/MisNotasEstudiante.css";

export default function MisNotasEstudiante() {

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  const [notas, setNotas] = useState([]);
  const [periodo, setPeriodo] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchNotas = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API}/notas-estudiante/mis-notas`,
        { headers }
      );

      setNotas(res.data.notas || []);
      setPeriodo(res.data.periodo || null);

    } catch (err) {
      console.error("❌ Error notas:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotas();
  }, []);

  const promedio =
    notas.length > 0
      ? (
          notas.reduce(
            (acc, n) => acc + Number(n.nota || 0),
            0
          ) / notas.length
        ).toFixed(2)
      : 0;

  if (loading) {
    return <div className="notas-loading">Cargando notas...</div>;
  }

  return (
    <div className="notas-container">

      <h2>📊 Mis Notas</h2>

      {periodo && (
        <div className="periodo-box">
          📅 Periodo activo: <b>{periodo.nombre}</b>
        </div>
      )}

      <div className="resumen-box">
        📈 Promedio general: <b>{promedio}</b>
      </div>

      {notas.length === 0 ? (
        <div className="empty-box">
          No tienes notas registradas
        </div>
      ) : (
        <div className="notas-grid">

          {notas.map((n) => (
            <div key={n.id} className="nota-card">

              <h3>{n.materia}</h3>

              <div className="nota-valor">
                {Number(n.nota).toFixed(2)}
              </div>

              <p>{n.desempeno || "Sin desempeño"}</p>

              <span className="periodo-tag">
                {n.periodo}
              </span>

            </div>
          ))}

        </div>
      )}

    </div>
  );
}